import PropTypes from 'prop-types'

function withPropType (obj) {
  obj.propType = PropTypes.oneOf(Object.values(obj))
  return obj
}

export const FormTypes = withPropType({
  PRODUCTION: 'production',
  STOPPAGE: 'stoppage',
  REALIZATION: 'realizationProduction',
  REALIZATION_SCRAP: 'realizationScrap',
  REALIZATION_STOPPAGE: 'realizationStoppage',
  REALIZATION_CHANGEOVER: 'realizationChangeover',
  REALIZATION_UNREPORTED: 'realizationUnreported',
  BREAKDOWN_START: 'breakdownStart',
  BREAKDOWN_FINISH: 'breakdownFinish'
})

export const Modes = withPropType({
  PLANNING: 'planning',
  REALIZATION: 'realization'
})
